import React, { useRef } from 'react';
import useStyles from './styles';

function BallClickEffect({children, style, selected}) {
  const c = useStyles();
  const containerRef = useRef(null);
  const ballRef = useRef(null);
  

  const onClick = (e) => {
    var rect = containerRef.current.getBoundingClientRect();
    var left = e.clientX - rect.left;
    var top = e.clientY - rect.top;
    ballRef.current.style.top = top + "px";
    ballRef.current.style.left = left + "px";
    ballRef.current.classList.remove(c.clickedBall);
    setTimeout(() => {
      if (ballRef.current) {
        ballRef.current.classList.add(c.clickedBall);
      }
    }, 20);
  }


  return (
    <div ref={containerRef} onClick={onClick} style={style || {}} className={c.container + " " + (selected ? "selected" : "")}>
      <div className={c.children}>
        {children}
      </div>
      <div ref={ballRef} className={c.ball}></div>
    </div>
  );
}

export default BallClickEffect;